/*
 * @Author: xxx
 * @Date: 2023-03-16 13:32:58
 * @LastEditors: xxx
 * @LastEditTime: 2023-03-16 13:35:59
 * @Description: 学籍
 */
import request from "@/utils/request";

// 获取学籍
export function getInfo(params: any) {
  return request({
    url: "api/client/cert/search",
    method: "get",
    params
  });
}
